// Lightweight local cache for toggle states (frontend-only)
// Keys are namespaced by shop when available

const NAMESPACE = 'cloudcache_toggle_cache_v1';

function get_storage() {
  try {
    return JSON.parse(localStorage.getItem(NAMESPACE) || '{}');
  } catch (_) {
    return {};
  }
}

function set_storage(obj) {
  try {
    localStorage.setItem(NAMESPACE, JSON.stringify(obj));
  } catch (_) {}
}

export function make_key(shop, feature_name) {
  const shop_key = shop && typeof shop === 'string' && shop.length > 0 ? shop : 'global';
  return `${shop_key}::${feature_name}`;
}

export function get_toggle_state(shop, feature_name, default_value = false) {
  const key = make_key(shop, feature_name);
  const data = get_storage();
  if (Object.prototype.hasOwnProperty.call(data, key)) {
    return !!data[key];
  }
  return default_value;
}

export function set_toggle_state(shop, feature_name, enabled) {
  const key = make_key(shop, feature_name);
  const data = get_storage();
  data[key] = !!enabled;
  set_storage(data);
}
